export default __webpack_public_path__ + "static/media/youth_banner.5b1eea86.jpg";